import * as yup from 'yup';

export const AdditionalFeaturesSchema = yup.object({
	neuralEnable: yup.bool(),
	neuralLimit: yup.number(),
});
